import { render, staticRenderFns } from "./StarRatingListItem.vue?vue&type=template&id=90bddc20&scoped=true"
import script from "./StarRatingListItem.vue?vue&type=script&lang=js"
export * from "./StarRatingListItem.vue?vue&type=script&lang=js"
import style0 from "./StarRatingListItem.vue?vue&type=style&index=0&id=90bddc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bddc20",
  null
  
)

export default component.exports